import { MenuItemURL } from './constants';

/**
 * 현재 client url이 parameter로 전달된 string으로 시작하는지 여부를 반환.
 * string에 protocol이 포함된 경우 제거하고 비교.
 */
export function isCurrentURLStartsWith(url) {
  const urlWithoutProtocol = url.split('//').slice(-1)[0];
  return location.href.split('//')[1].startsWith(urlWithoutProtocol);
}

export function getCurrentMenuItemIdFromLocation() {
  const entry =
    Object.entries(MenuItemURL).find(([, url]) => {
      return isCurrentURLStartsWith(url);
    }) ?? [];
  return entry[0];
}
